/** Where "Open Slack" lands: the Finlay app DM or a channel. */
export type SlackTarget =
  | { teamId?: string | null; appId: string }
  | { teamId: string; channelId: string };

/**
 * `app_redirect` opens the Slack desktop or mobile app when installed and
 * Slack in the browser otherwise; `slack://` links need the native app.
 */
export const slackAppRedirectUrl = (target: SlackTarget) => {
  const url = new URL('https://slack.com/app_redirect');

  if ('appId' in target) url.searchParams.set('app', target.appId);
  else url.searchParams.set('channel', target.channelId);

  if (target.teamId) url.searchParams.set('team', target.teamId);

  return url.toString();
};
